
/**
 * True se string tem algum caracter. Um trim() é executado ates.
 * "" => false, " a " => true
 * 
 * @param data any
 * @returns boolean
 */
export const stringIsNotEmpty = (data: any) => data && typeof data === "string" && (data as string).trim().length;

/**
 * Dado um objeto, retorna o objeto ou uma string vazia se o objeto for uma expressão falsa em javascript.
 * 
 * @param data any
 * @returns string
 */
export const stringOrEmptyString = (data: any, orStr = "") => data || orStr;

/**
 * Verifica se um objeto é igual a string "1".
 * "1" => true, " 1 " => true (um trim() acontece).
 * 
 * @param data any
 * @returns boolean
 */
export const stringIsEqual1 = (data: any) => typeof data === "string" && data.trim() === "1";